// TODO: The following should potentially be configuration variables.
// See: https://github.com/keysolutions/shopaholic/issues/11
export var stripePublicKey = "pk_live_eWgJbHmN0KlC8PGdpGVD4apb00tnNJmEPX";
export var environment = "live";
if (location && ["localhost", "beta.bayfieldbrewingco.com"].includes(location.hostname)) {
  stripePublicKey = "pk_test_wROG9jUOf1birJ2BpClmY05z00uX1Y5KhY";
  environment = "dev";
}
